import React, { useEffect, useState, useRef } from 'react';
import { Table, message } from '@drip/drip-design';
import Copy from '@/components/copy';
import ExportData from '../export-data';
import { formatSearchPrice } from '@/common/utils';
import { INDICATORS_DATA, INTEGER, ONE_DECIMAL, TWO_DECIMAL, PERCENTAGE } from '../../config';
import apis from '../../../../../../apis';

const INDICATORS_ARRAY_DATA = [
  ...INDICATORS_DATA[0].items,
  ...INDICATORS_DATA[1].items,
  ...INDICATORS_DATA[2].items,
  ...INDICATORS_DATA[3].items,
  ...INDICATORS_DATA[4].items,
];
//const isShowSorter = ['search_ord_deal_ord_amt', 'search_ord_out_ord_amt'];
function AnalysisTable(props) {
  const { tabsIdx, param } = props;
  const [sorterCache, setSorter] = useState({ascending: false, propertyName: "search_uv" });
  const [bosData, setBosData] = useState([]);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(false);
  const [params, setParams] = useState(Object.assign({}, { ...param }));

  /**
   * 获取数据
   */
  const getData = (data) => {
    const queryParam = Object.assign({}, params, data);
    setParams(queryParam);
    console.log('加载了', queryParam);
    setLoading(true);
    if (!queryParam.indicators.length) {
      setTotal(0);
      setBosData([]);
      setLoading(false);
    } else {
      apis
        .platDataOneServiceQuery(queryParam)
        .then((res) => {
          setLoading(false);
          const { data, msg, ret } = res;
          if (ret === '0' && data?.bos) {
            setTotal(data?.total || 0);
            setBosData(data?.bos || []);
          } else {
            setTotal(0);
            setBosData([]);
            throw msg || '表格接口请求失败';
          }
        })
        .catch((ex) => {
          message.error(ex);
          setTotal(0);
          setBosData([]);
          setLoading(false);
        });
    }
  };

  useEffect(() => {
    if (param?.beginDate) {
      setSorter({ascending: false, propertyName: "search_uv" });
      getData(Object.assign({}, { ...param }, { pageNo: 1, orders: sorterCache }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [param]);
  /**
   * 获取指标数据
   */
  const getIndicatorsData = (indicators, value) => {
    if (INTEGER.includes(indicators.value)) {
      return formatSearchPrice(value, '--', 1, '', 0);
    } else if (ONE_DECIMAL.includes(indicators.value)) {
      return formatSearchPrice(value, '--', 1, '', 1);
    } else if (TWO_DECIMAL.includes(indicators.value)) {
      return formatSearchPrice(value);
    } else if (PERCENTAGE.includes(indicators.value)) {
      return formatSearchPrice(value ? value * 100 : value, '--', 1, '%');
    }
  };
  /**
   * 获取指标项
   * @returns
   */
  const getIndicators = (item) => {
    return {
      dataIndex: item.value,
      sorter: true || isShowSorter.includes(item.value),
      sortOrder: item.value == sorterCache?.propertyName ? (sorterCache?.ascending ? 'ascend' : 'descend') : false,
      title: item.name,
      align: 'right',
      render(record) {
        return (
          <div className="indicators-data">
            <span className="indicators-data-number"> {getIndicatorsData(item, record)}</span>
          </div>
        );
      },
    };
  };
  const getIndicatorsRatio = (item) => {
    return {
      dataIndex: item.value + '_ratio',
      title: '较对比日',
      align: 'right',
      render(record) {
        const value = formatSearchPrice(record ? record * 100 : record, '--', 1, '%');
        const isHasData = value !== '--';
        return (
          <div className="indicators-data">
            <span className="indicators-data-number"> {value}</span>
            {isHasData && Number(record) ? (
              <i className={`indicators-data-icon ${record >= 0 ? '' : 'down'} `}></i>
            ) : null}
          </div>
        );
      },
    };
  };
  const getIndicatorsColumns = () => {
    let indicatorsColumns = [];
    INDICATORS_ARRAY_DATA.map((item) => {
      if (params.indicators.includes(item.value)) {
        indicatorsColumns.push(getIndicators(item));
        indicatorsColumns.push(getIndicatorsRatio(item));
      }
    });
    return indicatorsColumns;
  };

  /**
   * 获取商品分析信息
   * @returns
   */
  const getGoodsColumns = () => {
    const goodsColumns = [
      {
        title: '商品信息',
        width: 268,
        align: 'left',
        fixed: true,
        render(record) {
          const { sku_id, sku_name, sku_img_url } = record || {};
          return (
            <div className="sku-goods">
              <div className="sku-img">
                <img src={sku_img_url}></img>
              </div>
              <div className="sku-info">
                <div
                  className={`sku-info-title ellipsis-1-line ${params.indicators.length ? 'ellipsis-title' : ''}`}
                  title={sku_name}
                >
                  {sku_name}
                </div>
                <div className="sku-info-id">
                  sku：
                  <Copy text={sku_id} />
                </div>
              </div>
            </div>
          );
        },
      },
    ];
    return [...goodsColumns, ...getIndicatorsColumns()];
  };

  /**
   * 获取店铺分析信息
   * @returns
   */
  const getShopColumns = () => {
    const shopColumns = [
      {
        title: '店铺信息',
        width: 175,
        align: 'left',
        fixed: true,
        render(record) {
          const { shop, shop_name } = record || {};
          return (
            <div className="shop-info">
              <div className="shop-info-title ellipsis-1-line" title={shop_name}>
                {shop_name}
              </div>
              <div className="shop-info-id">
                <Copy text={shop} />
              </div>
            </div>
          );
        },
      },
    ];
    return [...shopColumns, ...getIndicatorsColumns()];
  };

  /**
   * 获取关键词分析信息
   * @returns
   */
  const getKeywordsColumns = () => {
    const keyWordsColumns = [
      {
        title: '关键词',
        width: 130,
        align: 'left',
        fixed: true,
        render(record) {
          return (
            <div className="keyword ellipsis-1-line" title={record?.keyword}>
              {record?.keyword}
            </div>
          );
        },
      },
    ];
    return [...keyWordsColumns, ...getIndicatorsColumns()];
  };

  /**
   * 获取首层表格
   * @returns
   */
  const getColumns = () => {
    switch (tabsIdx) {
      case 0:
        return getGoodsColumns();
      case 1:
        return getKeywordsColumns();
      case 2:
        return getShopColumns();
    }
  };
  return (
    <>
      <ExportData param={params} tabsIdx={tabsIdx} />
      <div className="analysis-table-list">
        <Table
          loading={loading}
          columns={getColumns()}
          dataSource={bosData}
          pagination={{
            total: total,
            current: params.pageNo,
            pageSize: params.pageSize,
          }}
          rowKey={(record) => record.sku_id || record.keyword || record.shop}
          scroll={{ x: params.indicators.length * 130 * 2 + 268 }}
          rowClassName={(record, index) => {
            const rowColor = index % 2 === 0 ? 'cell-single-color' : '';
            return rowColor;
          }}
          onChange={(pagination, filters, sorter, { action }) => {
            if (action == 'sort') {
              const { column, order } = sorter;
              const sorterObj = column?.dataIndex
                ? {
                    propertyName: column?.dataIndex,
                    ascending: order === 'ascend' ? true : false,
                  }
                : {};
              setSorter(sorterObj);
              getData({
                pageNo: 1,
                orders: sorterObj,
              });
            }
            if (action == 'paginate') {
              getData({
                pageNo: pagination.current,
                orders: sorterCache,
              });
            }
          }}
        />
      </div>
    </>
  );
}

export default AnalysisTable;
